import React from 'react';
import { formatPesoAmount } from '../../utils/money';
import { isOfferFormat } from './OfferAvailabilityDialog';

const dateLabel = (value) => new Date(value).toLocaleString('es-CL', {
  timeZone: 'America/Santiago', day: '2-digit', month: 'short', year: 'numeric',
  hour: '2-digit', minute: '2-digit',
});

export const getCurrentOfferState = (format, now = Date.now()) => {
  const policy = format?.offerAvailability;
  if (!policy || policy.endedAt || !isOfferFormat(format)) return null;
  const start = Date.parse(policy.startsAt || policy.enabledAt);
  const end = Date.parse(policy.expiresAt);
  if (!Number.isFinite(start) || !Number.isFinite(end) || end <= now
    || (policy.maxQuantity != null && Number(policy.soldQuantity || 0)
      >= Number(policy.maxQuantity) - Number(policy.tolerance || 0))) return null;
  if (start > now) return 'Programada';
  return format.isAvailable ? 'Activa' : 'No disponible';
};

const QuickOfferSummary = ({ offer, now, colSpan = 5, canUpdate = false, disabled = false, saving = false, error = '', label = '', onEdit, onEnd }) => {
  const state = getCurrentOfferState(offer, now);
  if (!state) return null;
  const policy = offer.offerAvailability;
  const price = offer.sellingPrice;
  return <tr data-testid={`quick-offer-${offer.id}`} className="border-t border-amber-100 bg-amber-50/70">
    <td colSpan={colSpan} className="py-2 pl-10 pr-3">
      <div className="rounded-lg border border-amber-200 bg-white px-3 py-2">
        <div className="flex flex-wrap items-center gap-2">
          <span className={`rounded-full border px-2 py-0.5 text-[11px] font-bold ${state === 'Activa'
            ? 'border-emerald-200 bg-emerald-100 text-emerald-800' : 'border-blue-200 bg-blue-100 text-blue-800'}`}>Oferta {state.toLowerCase()}</span>
          <strong className="text-sm text-amber-950">{price == null ? 'Sin precio' : `$${formatPesoAmount(price)}`}{offer.metricUnit && ` / ${offer.metricUnit}`}</strong>
        </div>
        {canUpdate && <div className="mt-2 flex flex-wrap gap-2">
          <button type="button" aria-label={`Editar Oferta de ${label}`} disabled={disabled || saving} onClick={onEdit}
            className="min-h-9 rounded-md border border-amber-300 px-3 py-1 text-xs font-bold text-amber-800 hover:bg-amber-50 disabled:opacity-50">Editar</button>
          <button type="button" aria-label={`Quitar Oferta de ${label}`} disabled={disabled || saving} onClick={onEnd}
            className="min-h-9 rounded-md border border-red-200 px-3 py-1 text-xs font-bold text-red-700 hover:bg-red-50 disabled:opacity-50">{saving ? 'Guardando…' : 'Quitar Oferta'}</button>
        </div>}
        {error && <p role="alert" className="mt-2 text-xs font-semibold text-red-700">{error}</p>}
        <p className="mt-1 text-xs text-slate-600">
          Desde {dateLabel(policy.startsAt || policy.enabledAt)} · hasta {dateLabel(policy.expiresAt)} (hora de Chile)
        </p>
        {policy.maxQuantity != null && <p className="mt-1 text-xs text-slate-600">
          {Number(policy.soldQuantity || 0).toLocaleString('es-CL')} / {Number(policy.maxQuantity).toLocaleString('es-CL')} {policy.unit || offer.metricUnit} vendidos
          {Number(policy.tolerance) > 0 && ` · tolerancia: ${Number(policy.tolerance).toLocaleString('es-CL')} ${policy.unit || offer.metricUnit}`}
        </p>}
        {policy.detailVarietyPriceId && <p className="mt-1 text-xs text-slate-700">
          {state === 'Programada' ? 'Al comenzar, Detalle se marcará como no disponible una vez.'
            : 'Detalle se marcó como no disponible al comenzar la oferta.'} Puedes habilitarlo manualmente sin finalizar la oferta.
        </p>}
      </div>
    </td>
  </tr>;
};

export default QuickOfferSummary;
